import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import StepTitle from './customComponents/StepTitle/StepTitle'
import { SelectionCardHolder } from './Styles/selectionCardStyle'
import { Alert, Col, Modal, Row } from 'antd'
import SelectionCardItemComponent from './SelectionCardItemComponent'
import Colors from '../themes/Colors'
import Text from 'antd/lib/typography/Text'
import ModalChangeCreationTypeWarning from './ModalChangeCreationTypeWarning'
import HiddenByCpmTypeContainer from '../newSrc/shared/containers/HiddenByCpmTypeContainer'

const SelectionCardComponent = ({creationType, setCreationType, errors, blockCreationType, resetCampaignData}) => {
  const { t } = useTranslation()
  const [openBlockedCreationTypeModal, setOpenBlockedCreationTypeModal] = useState(false)
  const [action, setAction] = useState("")
  const [showWarning, setShowWarning] = useState(false)

  const handleChangeStatus = (status) => {
    if (blockCreationType) {
      setAction(status)
      setOpenBlockedCreationTypeModal(true)
      return
    }
    setShowWarning(true)
    setCreationType(status)
  }

  const handleOk = (action) => {
    setCreationType(action)
    setOpenBlockedCreationTypeModal(false)
    setShowWarning(false)
    resetCampaignData()
  }

  const handleCancel = () => {
    setOpenBlockedCreationTypeModal(false)
    setShowWarning(false)
  }

  return (
    <SelectionCardHolder >
      <StepTitle>
        {t('Selection card title')}
      </StepTitle>
      <Row gutter={[16, 16]} type="flex">
        <Col xs={24} md={12}>
          <SelectionCardItemComponent
            title={t("Create campaign step title")}
            description={
              <HiddenByCpmTypeContainer fallback={t("Create campaign step description_cpmi")}>
                {t("Create campaign step description")}
              </HiddenByCpmTypeContainer>
            }
            checked={creationType === "createCampaign"}
            onClick={() => handleChangeStatus("createCampaign")}
          />
        </Col>
        <Col xs={24} md={12}>
          <SelectionCardItemComponent 
            title={t("Make a proposal step title")}
            description={t("Make a proposal step description")}
            checked={creationType === "makeProposal"}
            onClick={() => handleChangeStatus("makeProposal")}
          />
        </Col>
      </Row>

      {errors["creationType"] && (
        <div style={{ marginTop: "5px" }}>
          <Text type="danger">{errors["creationType"]}</Text>
        </div>
      )}
      {showWarning && (
      <Alert
        description={t('Once you proceed to step 2, you won’t be able to change the creation type (campaign or proposal) without losing your settings.')}
        type="warning"
        showIcon
        closable
        />
      )}
      <ModalChangeCreationTypeWarning
        isOpen={openBlockedCreationTypeModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
        action={action}
      />
    </SelectionCardHolder>
  )
}

export default SelectionCardComponent